import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Login from './Login';
import Dashboard from './Dashboard';
import Quiz from './Quiz';
import Home from './Home';
import TextbookViewer from './TextbookViewer';
import VideoPlayer from './VideoPlayer';
import PodcastPlayer from './PodcastPlayer';
import Verify from './Verify';
import Profile from './Profile';

import ChatbotTutor from './ChatbotTutor';
import './App.css';
import { ThemeProvider } from '@mui/material/styles';
import theme from './theme';
import { AuthProvider } from './context/AuthContext';

// Import axios configuration for automatic user ID headers
import './utils/axiosConfig';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <AuthProvider>
      <div className="App" style={{ display: 'block' }}>
        <Routes>
          <Route path="/" element={<Login />} />

          {/* Protected routes */}
          <Route element={<ProtectedRoute />}>
            <Route path="/home" element={<Home />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/textbook/:courseId" element={<TextbookViewer />} />
            <Route path="/video/:courseId" element={<VideoPlayer />} />
            <Route path="/podcast/:courseId" element={<PodcastPlayer />} />
            <Route path="/quiz/:courseId" element={<Quiz />} />
            <Route path="/verify" element={<Verify />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/tutor/:courseId" element={<ChatbotTutor />} />
          </Route>
        </Routes>
      </div>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
